<template>
	<section class="ui-fac-news-card" @click="viewNews(id)">
		<div class="infos">
			<ui-tag-line :text="category.name" />
			<div class="title">{{ title }}</div>
			<div class="date">
				<i class="fal fa-calendar-alt"></i>
				{{ createdAt | moment('DD [de] MMMM [de] YYYY [às] HH:mm:ss') }}
			</div>
			<div class="text">
				<p v-add-html="resume(article, 350)"></p>
			</div>
		</div>
		<div class="control">
			<i class="fal fa-angle-right"></i>
		</div>
	</section>
</template>

<script>
	import { uiTagLine } from '@/components/ui/tags'
	import helpers from '@/mixins/helpers'

	export default {
		name: 'ui-facilita-news-card',
		
		components: { uiTagLine },

		mixins: [helpers],

		props: {
			data: {
				type: Object,
				required: false,
			},
		},

		data() {
			return {
				id: null,
				category: null,
				title: null,
				createdAt: null,
				article: null,
			}
		},

		methods: {
			setPropValue() {
				if (this.data) {
					Object.keys(this.data).forEach((key) => {
						let propKey = key.replace(/([-_]\w)/g, (g) => g[1].toUpperCase())
						return this.$data[propKey] = this.data[key]
					})
				}
			},

			viewNews(id) {
				this.$router.push({
					name: 'news.view',
					params: { id: id },
				})
			},
		},

		created() {
			this.setPropValue()
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
